export default "__VITE_ASSET__CdmpPc2H__"